import React from 'react';

import { ReduxRouter } from '@lagunovsky/redux-react-router';
import { App as AntdApp } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { history, persistor, store } from 'redux/reducers';

import { rehydrateAndVerify } from 'utils/AuthUtils';

import App from './App';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import appI18n from './config/i18n';
import { SocketProvider } from './context/WebSocketContext';
import reportWebVitals from './reportWebVitals';
import setUpInterceptor from './utils/AxiosInterceptos';

import './App.scss';

setUpInterceptor();

document.title = appI18n.t('common.app_title');
dayjs.locale(appI18n.language === 'en' ? 'en' : 'es');
appI18n.on('languageChanged', () => {
  document.title = appI18n.t('common.app_title');
  dayjs.locale(appI18n.language === 'en' ? 'en' : 'es');
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <PersistGate
      loading={<LoadingScreen text={appI18n.t('common.loading')} />}
      persistor={persistor}
      onBeforeLift={async () => {
        await rehydrateAndVerify(persistor);
      }}
    >
      <AntdApp>
        {/* Un solo router: ReduxRouter con el history compartido del store */}
        <ReduxRouter history={history}>
          <SocketProvider>
            <App />
          </SocketProvider>
        </ReduxRouter>
      </AntdApp>
    </PersistGate>
  </Provider>
);

reportWebVitals();
